import { render, staticRenderFns } from "./fault-list.vue?vue&type=template&id=85c1b926&scoped=true&"
import script from "./fault-list.vue?vue&type=script&lang=js&"
export * from "./fault-list.vue?vue&type=script&lang=js&"
import style0 from "./fault-list.vue?vue&type=style&index=0&id=85c1b926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c1b926",
  null
  
)

export default component.exports